<template>
  <div class="fixed">
    <div
      class="art-image"
      :class="{ 'not-available': !image && isImageNotAvailable, 'with-art-scroll': images.length > 1 }"
      @click="openImage()"
      ref="imageBlock"
      v-show="imgLoaded"
    >
      <img v-lazy="src" v-if="isImage" ref="mainImage" />
      <div
        v-if="isImage"
        :style="
          'background-image: url(' +
          src +
          '); background-repeat: no-repeat; background-size: contain; width: 100%; height: 100%;'
        "
      ></div>

      <video controls :autoplay="autoplay" preload="auto" v-if="isVideo" ref="media">
        <source
          :key="index"
          v-for="(version, index) in image.versions"
          :src="mediaBaseUrl + version.src"
          :type="version.type"
        />
        <i class="fa fa-ban" v-translate>La vidéo est incompatible avec votre navigateur</i>
      </video>
      <audio controls :autoplay="autoplay" preload="auto" v-if="isAudio" ref="media">
        <source
          :key="index"
          v-for="(version, index) in image.versions"
          :src="mediaBaseUrl + version.src"
          :type="version.type"
        />
        <i class="fa fa-ban" v-translate>Le fichier audio est incompatible avec votre navigateur</i>
      </audio>
      <div class="icon-not-available" v-if="!image && isImageNotAvailable">
        <i class="icon-img_pas_dispo"></i>
      </div>
    </div>

    <div v-if="images.length > 1" class="art-scroll-container">
      <perfect-scrollbar :options="scrollOptions" class="art-scroll">
        <div class="art-scroll-content">
          <div class="item" :key="index" v-for="(img, index) in images" :class="{ active: current === index }">
            <a href @click.prevent="setCurrent(index)">
              <ArtworkImage :image="img" version="100" v-if="img.type === 'image'" />
              <div class="thumb-icon" v-if="img.type === 'video' || img.type === 'audio'">
                <i
                  :class="{ 'fa-music': img.type == 'audio', 'fa-video-camera': img.type == 'video' }"
                  class="fa fa-2x media-icon"
                ></i>
              </div>
            </a>
            <i class="icon icon-tri_up" v-if="current === index"></i>
          </div>
        </div>
        <div class="counter">{{ current + 1 }}/{{ images.length }}</div>
      </perfect-scrollbar>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import ArtworkImage from './ArtworkImage.vue';

import { mediaBaseUrl } from 'config';

import stickybits from 'stickybits';

export default {
  props: {
    autoplay: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    ArtworkImage,
  },
  mounted() {
    this.toggleImageLink();
    if (this.$refs.media) {
      this.$refs.media.load();
    }
    stickybits(this.$el);
  },
  computed: {
    ...mapGetters('artworks', ['images', 'currentImage', 'artwork']),
    current() {
      return this.currentImage;
    },
    src() {
      return `https://images.navigart.fr/1000/${this.image.file_name}`;
    },
    image() {
      return this.images[this.current] || this.mediaImage[this.current];
    },
    mediaImage() {
      const { isHeader } = this.$route.query;
      if (!this.artwork.medias || !!isHeader === true || isHeader === undefined) {
        return [];
      }

      return this.artwork.medias.filter((i) => i.type === 'image');
    },
    isSeparable() {
      return this.artwork.type === 'separable';
    },
    isImageNotAvailable() {
      const { isHeader } = this.$route.query;
      return isHeader && this.isSeparable ? this.artwork.recap_image_unavailable : this.artwork.image_unavailable;
    },
    type() {
      const { type = undefined } = this.image || {};
      return type;
    },
    isImage() {
      return this.type === 'image';
    },
    isVideo() {
      return this.type === 'video';
    },
    isAudio() {
      return this.type === 'audio';
    },
  },
  methods: {
    ...mapMutations('artworks', ['assign']),
    setCurrent(index) {
      this.assign({ name: 'currentImage', data: index });
    },
    openImage() {
      if (this.image && this.image.html_link) {
        const openedWindow = window.open(this.image.html_link, '_blank');
        openedWindow.focus();
      }
    },
    toggleImageLink() {
      if (this.image && this.image.html_link) {
        this.$refs.imageBlock.dataset.content = this.image.html_text;
        this.$refs.imageBlock.classList.add('image-link');
      } else {
        this.$refs.imageBlock.dataset.content = '';
        this.$refs.imageBlock.classList.remove('image-link');
      }
    },
  },
  watch: {
    image(newValue) {
      if (this.$refs.media && newValue) {
        this.$refs.media.load();
      }
      this.toggleImageLink();
    },
  },
  data() {
    return {
      mediaBaseUrl,
      scrollOptions: {
        suppressScrollY: true,
      },
      imgLoaded: true,
    };
  },
};
</script>

<style lang="less">
.art-image {
  display: block;
  position: relative;
  margin: 15px;

  &.image-link {
    cursor: pointer;

    &:after {
      font-size: 18px;
      font-weight: 400;
      content: attr(data-content) '';
      top: 50%;
      right: 50%;
      position: absolute;
      padding: 10px;
      background-color: rgba(229, 229, 229, 0.6);
    }
  }

  img {
    width: 100%;
    height: 100%;
  }

  .background-contain {
    background-size: contain;
  }

  &.not-available {
    background-image: url(../../img/not-available-bg.png);
    height: 100%;
    min-height: 100%;
    position: relative;
    min-height: 300px;
  }

  .icon-not-available {
    width: 203px;
    height: 94px;
    position: absolute;
    top: 50%;
    left: 50%;
    line-height: 94px;
    text-align: center;
    margin: -47px 0 0 -101px;
  }
}

@media (max-width: 768px) {
  .art-image {
    .background-contain {
      display: none;
    }
    img {
      display: block;
    }
  }
}

@media (min-width: 992px) {
  .art {
    //height: 100%;
    .fixed {
      height: 90vh;
      //height: 90%;
      //width: 100%;
      //position: absolute;
      max-width: inherit;
      width: 100%;
    }
  }

  .art-image {
    height: 90%;
    &.with-art-scroll {
      height: 85%;
    }
    img {
      display: none;
    }
  }
}
</style>
